import { createTranslate, ENGLISH, type Translate } from "@khazzin/i18n";
import { createContext, type ReactNode, useContext } from "react";

/**
 * The translator for the design system's own words (ADJ-M03-1): "More",
 * "Search", "No options", "3 selected".
 *
 * The patterns take `t` as a prop because a screen already holds one. A
 * primitive like `Select` is used in a hundred places that never passed one,
 * and threading a prop through all of them for four words would be the wrong
 * trade — so each app's locale provider publishes its `t` here once, and a
 * primitive outside any provider (a test, the gallery) falls back to English.
 */
const UiTextContext = createContext<Translate | null>(null);

let english: Translate | null = null;

export function UiTextProvider({ t, children }: { t: Translate; children: ReactNode }) {
	return <UiTextContext.Provider value={t}>{children}</UiTextContext.Provider>;
}

/** The app's `t`, or English outside a provider. */
export function useUiText(): Translate {
	const t = useContext(UiTextContext);
	if (t !== null) {
		return t;
	}
	english ??= createTranslate("en", ENGLISH);
	return english;
}
